import { addPromo, fetchPromos } from 'shared/models/api';

export const SHOW_PROMO = 'SHOW_PROMO';
export const ADD_PROMO = 'ADD_PROMO';
export const ADD_CREDIT = 'ADD_CREDIT';
export const ADD_PROMO_ERROR = 'ADD_PROMO_ERROR';
export const ADD_PROMO_LOADING = 'ADD_PROMO_LOADING';
export const FETCH_PROMOS_LOADING = 'FETCH_PROMOS_LOADING';
export const FETCH_PROMOS_SUCCESS = 'FETCH_PROMOS_SUCCESS';
export const FETCH_PROMOS_ERROR = 'FETCH_PROMOS_ERROR';

const init = { codes: [], error: null, loading: false };

export default function(state = init, action = {}) {
  switch (action.type) {
    case SHOW_PROMO:
      return { ...state, show: action.display };
    case ADD_PROMO:
      return {
        ...state,
        codes: [action.promo, ...state.codes],
        error: null,
        loading: false
      };
    case ADD_CREDIT:
      return {
        ...state,
        credit: mergeCredits(state.credit, action.credit),
        error: null,
        loading: false
      };
    case ADD_PROMO_ERROR:
      return { ...state, error: action.error, loading: false };
    case ADD_PROMO_LOADING:
      return { ...state, error: null, loading: true };
    case FETCH_PROMOS_LOADING:
      return { ...state, loading: true };
    case FETCH_PROMOS_SUCCESS:
      return {
        ...state,
        loading: false,
        codes: action.codes,
        credit: action.credit
      };
    case FETCH_PROMOS_ERROR:
      return { ...state, loading: false };
    default:
      return state;
  }
}

function mergeCredits(oldCredit, newCredit = {}) {
  const oldBalance = (oldCredit && oldCredit.balance) || 0;
  const oldVal = (oldCredit && oldCredit.val) || 0;
  const oldValue = (oldCredit && oldCredit.value) || 0;
  const newBalance = (newCredit && newCredit.balance) || 0;
  const newVal = (newCredit && newCredit.val) || 0;
  const newValue = (newCredit && newCredit.value) || 0;
  return {
    code: newCredit.code,
    value_type: newCredit.value_type,
    balance: oldBalance + newBalance,
    val: oldVal + newVal,
    value: oldValue + newValue
  };
}

export function apply(code) {
  return dispatch => {
    dispatch({ type: ADD_PROMO_LOADING });
    return addPromo(code)
      .then(result => {
        return result.value_type === 'credit'
          ? dispatch({ type: ADD_CREDIT, credit: result })
          : dispatch({ type: ADD_PROMO, promo: result });
      })
      .catch(error => {
        const message = error.body ? error.body.message : error.message;
        dispatch({ type: ADD_PROMO_ERROR, error: message });
      });
  };
}

export function loadPromos(opts = {}) {
  return (dispatch, getState) => {
    if (getState().promo.loading) return;
    dispatch({ type: FETCH_PROMOS_LOADING });
    return fetchPromos(opts)
      .then(result => {
        return dispatch({
          type: FETCH_PROMOS_SUCCESS,
          codes: result.codes,
          credit: result.credit
        });
      })
      .catch(() => {
        return dispatch({ type: FETCH_PROMOS_ERROR });
      });
  };
}

export function showPromo(display) {
  return dispatch => {
    dispatch({ type: SHOW_PROMO, display });
    if (!display) dispatch({ type: ADD_PROMO_ERROR, error: null });
  };
}
